import { render, staticRenderFns } from "./Product1103001000011ogcbd.vue?vue&type=template&id=3636e026"
import script from "./Product1103001000011ogcbd.vue?vue&type=script&lang=js"
export * from "./Product1103001000011ogcbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3636e026')) {
      api.createRecord('3636e026', component.options)
    } else {
      api.reload('3636e026', component.options)
    }
    module.hot.accept("./Product1103001000011ogcbd.vue?vue&type=template&id=3636e026", function () {
      api.rerender('3636e026', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/deposit/Product1103001000011ogcbd.vue"
export default component.exports